import { useEffect, useState } from "react";
import { CalendarDays, CalendarRange, IndianRupee, Hourglass } from "lucide-react";
import { useAdminApi } from "./useAdminApi";
import { inr } from "@/lib/api";

export const Metrics = ({ tick }) => {
  const call = useAdminApi();
  const [m, setM] = useState(null);
  useEffect(() => {
    call("get", "/admin/metrics").then(setM).catch(() => {});
  }, [call, tick]);
  const items = [
    { icon: CalendarDays, label: "Today's appointments", value: m?.today, id: "metric-today" },
    { icon: CalendarRange, label: "Next 7 days", value: m?.week, id: "metric-week" },
    { icon: IndianRupee, label: "Consultation fees collected", value: m ? inr(m.fees_collected) : null, id: "metric-fees" },
    { icon: Hourglass, label: "Awaiting payment", value: m?.pending, id: "metric-pending" },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="admin-metrics">
      {items.map(({ icon: I, label, value, id }, i) => (
        <div key={id} className={`rounded-3xl p-5 border ${i === 2 ? "bg-teal text-white border-teal" : "bg-white border-slate-200/80"}`}>
          <I className={`h-5 w-5 ${i === 2 ? "text-mint" : "text-teal"}`} />
          <p className="mt-3 font-display text-3xl font-semibold" data-testid={id}>{value ?? "—"}</p>
          <p className={`text-xs mt-1 ${i === 2 ? "text-white/75" : "text-ink-muted"}`}>{label}</p>
        </div>
      ))}
    </div>
  );
};
